const adminInitializeBlock = ( initializeCallback, blockSelector ) => {
	return ( element ) => {
		const $blockContainer = element.find( blockSelector );

		initializeCallback( $blockContainer, true );
	};
};

export default adminInitializeBlock;